define(
    'postLogin/index',['./pollSession', './logout', './handleUnAuthorized'],
    function(pollSession, logout) {
        'use strict';
        return {
            retrying: pollSession.retrying,
            retryPopup: pollSession.retryPopup,
            allServicesLogout: logout.allServicesLogout,
            thisServiceLogout: logout.thisServiceLogout
        };
    }
);
